import { css } from "@emotion/react";

export const h100css = css`
  height: 100%;
`;

export const w100css = css`
  width: 100%;
`;
